import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import OffersBtnDecoration from '../../assets/icons/JSX/OffersBtnDecoration'
import { currencySymbol } from '../../domain/types'
//
//
const MovingPrice: React.FC<{ price: any; currency?: 'GEL' | 'USD' | 'EUR' | string }> = ({
  price,
  currency = 'GEL',
}) => {
  //
  const [scrollPosition, setScrollPosition] = useState(0)
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    if (price) {
      window.addEventListener('scroll', handleScroll, { passive: true })
    }
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [price])
  //
  //
  return price || price === 0 ? (
    <OfferPriceBox $pricePosition={scrollPosition}>
      <OfferPriceDiv $pricePosition={scrollPosition}>
        <OffersBtnDecoration />
        <span>
          {price} {currencySymbol(currency)}
        </span>
        <OffersBtnDecoration />
      </OfferPriceDiv>
    </OfferPriceBox>
  ) : null
}
//
//
const OfferPriceBox = styled.div<{ $pricePosition: number }>`
  position: fixed;
  right: 85px;
  top: 120px;
  z-index: 3;

  ${Responsive.tablet} {
    right: 10px;
    svg {
      display: none;
    }
  }

  ${Responsive.mobile} {
    top: 80px;
    right: 20px;
    svg {
      display: none;
    }
  }
`
const OfferPriceDiv = styled.div<{ $pricePosition: number }>`
  position: relative;
  background-color: ${Colors.primaryRed};
  width: fit-content;
  border-radius: 40px;
  padding-inline: 34px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.white};
  font-size: 22px;
  -webkit-box-shadow: 0px 0px 50px -10px ${Colors.primaryRed};
  box-shadow: 0px 0px 50px -10px ${Colors.primaryRed};
  user-select: none;
  pointer-events: none;

  svg {
    height: 55px;
    width: fit-content;
    &:first-child {
      position: absolute;
      left: -45px;
      bottom: 0;
    }
    &:last-child {
      position: absolute;
      top: 0;
      right: -45px;
      transform: rotate(180deg);
    }
  }

  ${Responsive.tablet} {
    height: 48px;
    padding-inline: 30px;
    svg {
      display: none;
    }
  }

  ${Responsive.mobile} {
    font-size: 18px;
    height: 48px;
    svg {
      display: none;
    }
    /*  */
    display: none;
  }
`
//
export default MovingPrice
